import React, { memo } from 'react';
import { DatePicker } from 'antd';
import { useStore } from 'zustand';
import { timesheetsStore } from 'entities/timesheet';

import styles from './TimesheetRangePicker.module.scss';

const { RangePicker } = DatePicker;

const TimesheetRangePicker: React.FC = () => {
  const range = useStore(timesheetsStore, (state) => state.selectedRange);
  const setSelectedRange = useStore(timesheetsStore, (state) => state.setSelectedRange);

  return (
    <RangePicker
      className={styles.rangePicker}
      picker="month"
      value={range}
      onChange={(dates) => {
        if (dates && dates[0] && dates[1]) {
          setSelectedRange([dates[0], dates[1]]);
        }
      }}
      allowClear={false}
    />
  );
};

export default memo(TimesheetRangePicker);
